import React from 'react';

import PropTypes from 'prop-types';

/**
 * ## PrinterAreaContainer
 *
 * Container that is used as a reference for
 * **ReactToPrint**. Everything that is wrapped
 * in this component is printable
 * https://github.com/gregnb/react-to-print/issues/96#issuecomment-582581330
 */

class PrinterAreaContainer extends React.Component {
    static propTypes = {
        children: PropTypes.node.isRequired,
    };

    render() {
        const { children } = this.props;

        return (
            // eslint-disable-next-line react/jsx-no-useless-fragment
            <>
                { children }
            </>
        );
    }
}

export default PrinterAreaContainer;
